import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phone", "countryCode"]
  static values = { initialCountry: String }

  async connect() {
    if (!this.hasPhoneTarget) return

    const module = await import("../vendors/intlTelInput")
    const intlTelInput = module.default || module

    const initialCountry = this.hasInitialCountryValue ? this.initialCountryValue.toLowerCase() : "in"

    this.iti = intlTelInput(this.phoneTarget, {
      initialCountry,
      separateDialCode: true,
      nationalMode: true
    })

    this.updatePhoneState()
    this.scheduleUpdate = () => requestAnimationFrame(() => this.updatePhoneState())
    this.phoneTarget.addEventListener("countrychange", this.scheduleUpdate)
    this.phoneTarget.addEventListener("input", this.scheduleUpdate)
  }

  disconnect() {
    if (this.scheduleUpdate) {
      this.phoneTarget.removeEventListener("countrychange", this.scheduleUpdate)
      this.phoneTarget.removeEventListener("input", this.scheduleUpdate)
    }

    if (this.iti) this.iti.destroy()
  }

  updatePhoneState() {
    const country = this.iti.getSelectedCountryData()
    const iso = country.iso2
    let digits = this.phoneTarget.value.replace(/\D/g, "")

    if (iso === "in") {
      digits = digits.replace(/^0+/, "")
      if (digits.length > 10) digits = digits.replace(/^(?:91|091|0091)/, "")
    }

    const maxLength = iso === "in" ? 10 : 15
    digits = digits.slice(0, maxLength)

    if (this.phoneTarget.value !== digits) this.phoneTarget.value = digits

    this.phoneTarget.maxLength = maxLength
    this.phoneTarget.setCustomValidity(iso === "in" && digits.length != 10 ? "Phone number must be exactly 10 digits" : "")

    if (this.hasCountryCodeTarget) this.countryCodeTarget.value = `+${country.dialCode}`
  }
}
